export default __webpack_public_path__ + "static/media/1392.b9a0806c.png";